import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-407df8f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-menu" }
const _hoisted_2 = { class: "content-menu__buttons" }
const _hoisted_3 = { class: "content-menu__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonSide = _resolveComponent("ButtonSide")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['box-menu', { collapse: _ctx.isCollapsed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ButtonSide, {
        "is-collapsed": _ctx.isCollapsed,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-menu')))
      }, null, 8, ["is-collapsed"]),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "contents", {}, undefined, true)
      ])
    ])
  ], 2))
}